import { Component, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent, TableRowSelectEvent } from 'primeng/table';
import { UserLeadsSingleComponent } from '../user-leads-single/user-leads-single.component';

export enum enumLeadRequestStatus {
  NUOVO = 1,
  INVIATO = 2,
  RICHIESTA_MODIFICA = 3,
  ANNULLATO = 4,
}

interface LeadRequestStatus {
  id: enumLeadRequestStatus;
  name: string;
}

interface LeadRequest {
  identifier: string;
  from: string;
  when: string;
  country: string;
  status: LeadRequestStatus;
}

@Component({
  selector: 'app-user-leads',
  templateUrl: './user-leads.component.html',
  styleUrl: './user-leads.component.scss',
})
export class UserLeadsComponent {
  @ViewChild('dt1') table?: Table;
  leads: LeadRequest[] = [];
  totalRecords = 0;
  loading = false;
  selectedLead?: LeadRequest;
  leadModal?: DynamicDialogRef;

  constructor(public dialogService: DialogService) {}

  getAllBookings(event: TableLazyLoadEvent) {
    this.leads = [
      {
        identifier: 'A024C87',
        from: 'Marta Favoccia',
        country: 'Grecia',
        status: { id: enumLeadRequestStatus.NUOVO, name: 'Nuovo' },
        when: '2025-03-10',
      },
      {
        identifier: 'F231X38',
        from: 'Daniele Guglia',
        country: 'Italia',
        status: { id: enumLeadRequestStatus.INVIATO, name: 'Nuovo' },
        when: '2025-03-10',
      },
      {
        identifier: 'P003I89',
        from: 'Valerio Moscetti',
        country: 'USA',
        status: { id: enumLeadRequestStatus.RICHIESTA_MODIFICA, name: 'Nuovo' },
        when: '2025-03-09',
      },
      {
        identifier: 'C231A51',
        from: 'Patrizia Falchi',
        country: 'Indonesia',
        status: { id: enumLeadRequestStatus.INVIATO, name: 'Inviato' },
        when: '2025-10-09',
      },
      {
        identifier: 'Z897V66',
        from: 'Mauro Monaci',
        country: 'Israele',
        status: {
          id: enumLeadRequestStatus.RICHIESTA_MODIFICA,
          name: 'Inviato',
        },
        when: '2025-10-07',
      },
      {
        identifier: 'P933T78',
        from: 'Adriano De Luigi',
        country: 'Marocco',
        status: { id: enumLeadRequestStatus.ANNULLATO, name: 'Inviato' },
        when: '2025-10-03',
      },
    ];
    this.totalRecords = this.leads.length;
  }

  open(e: TableRowSelectEvent) {
    const lead = e.data as LeadRequest;
    this.leadModal = this.dialogService.open(UserLeadsSingleComponent, {
      header: 'Richiesta di preventivo',
      width: '75vw',
      styleClass: 'modal-res',
      data: {
        leadRequest: lead,
      },
    });
  }
}
